var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comparison-table-cell"},[_c('div',{staticClass:"new-value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),(_vm.showOldValue)?_c('div',{staticClass:"old-value"},[_vm._v(_vm._s(_vm.oldValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }